export default {

	"sign_in": {
		"en": "Sign In",
		"pl": "Zaloguj się",
		"ru": "Войти",
		"ua": "Увійти"
	},

	"registration": {
		"en": "Registration",
		"pl": "Rejestracja",
		"ru": "Регистрация",
		"ua": "Реєстрація"
	},

	"accessibility": {
		"en": "Accessibility",
		"pl": "Dostępność",
		"ru": "Доступность",
		"ua": "Доступність"
	},

	"sign_language_interpreter": {
		"en": "Sign language interpreter",
		"pl": "Tłumacz języka migowego",
		"ru": "Переводчик жестового языка",
		"ua": "Перекладач мови жестів"
	},

	"high_contrast": {
		"en": "High contrast",
		"pl": "Wysoki kontrast",
		"ru": "Высокий контраст",
		"ua": "Висока контрастність"
	},

	"description_of_the_procedure": {
		"en": "Description of the procedure",
		"pl": "Opis procedury",
		"ru": "Описание процедуры",
		"ua": "Опис процедури"
	},

	"required_documents": {
		"en": "Required documents",
		"pl": "Wymagane dokumenty",
		"ru": "Необходимые документы",
		"ua": "Необхідні документи"
	},

	"charges": {
		"en": "Charges",
		"pl": "Opłaty",
		"ru": "Сборы",
		"ua": "Збори"
	},

	"a_full_description_of_the_service_": {
		"en": "A full description of the service and printable applications can be downloaded from the website",
		"pl": "Pełny opis usługi oraz wnioski do wydruku można pobrać ze strony",
		"ru": "Полное описание услуги и приложения для печати можно скачать с сайта",
		"ua": "Повний опис послуги та програми для друку можна завантажити з веб-сайту"
	},

	"reservation_action_confirm_1": {
		"en": "You must arrive at the office punctually within the prescribed period. Arrival after the designated time will result in an automatic cancellation of the booking.",
		"pl": "W wyznaczonym terminie należy przybyć punktualnie do urzędu. Przybycie po wyznaczonej godzinie będzie skutkować automatycznym anulowaniem rezerwacji.",
		"ru": "Вы должны прибыть в офис вовремя в установленный срок. Прибытие после указанного времени приведет к автоматической отмене бронирования.",
		"ua": "Ви повинні прибути в офіс у встановлений термін. Прибуття після визначеного часу призведе до автоматичного скасування бронювання."
	},

	"reservation_action_confirm_2": {
		"en": "Remember to have all the necessary documents ready before the appointment.",
		"pl": "Należy pamiętać, by przed umówioną wizytą mieć przygotowane wszystkie potrzebne dokumenty.",
		"ru": "Не забудьте подготовить все необходимые документы до приема.",
		"ua": "Не забудьте підготувати всі необхідні документи до зустрічі."
	},

	"reservation_action_confirm_3": {
		"en": "A detailed description of the procedures can be found in the online booking form and on the BIP website of the Gdynia City Hall.",
		"pl": "Szczegółowy opis procedur znajduje się w formularzu rezerwacji internetowej oraz na stronie BIP Urzędu Miasta Gdyni.",
		"ru": "Подробное описание процедуры можно найти в форме онлайн-бронирования и на веб-сайте BIP мэрии Гдыни.",
		"ua": "Детальний опис процедур можна знайти в онлайн-формі бронювання та на веб-сайті BIP мерії Гдині."
	},

	"confirmation_of_the_visit_booking": {
		"en": "Confirmation of the visit booking",
		"pl": "Potwierdzenie rezerwacji wizyty",
		"ru": "Подтверждение бронирования посещения",
		"ua": "Підтвердження бронювання візиту"
	},

	"ur_booking_has_been_canceled": {
		"en": "Your booking has been canceled",
		"pl": "Twoja rezerwacja została anulowana",
		"ru": "Ваше бронирование было отменено",
		"ua": "Ваше бронювання скасовано"
	},

	"go_to_gdynia_pl": {
		"en": "Go to gdynia.pl",
		"pl": "Przejdź do gdynia.pl",
		"ru": "Перейти на gdynia.pl",
		"ua": "Перейти на gdynia.pl"
	},

	"information": {
		"en": "Information",
		"pl": "Informacja",
		"ru": "Информация",
		"ua": "Інформація"
	},

	"cancel_booking": {
		"en": "Cancel booking",
		"pl": "Anuluj rezerwację",
		"ru": "Отменить бронирование",
		"ua": "Скасувати бронювання"
	},

	"cancelling_the_reservation": {
		"en": "Cancelling the reservation",
		"pl": "Anulowanie rezerwacji",
		"ru": "Отмена бронирования",
		"ua": "Скасування бронювання"
	},

	"we_could_not_find_such_a_reservation": {
		"en": "We couldn't find such a reservation.",
		"pl": "Nie udało nam się znaleźć takiej rezerwacji.",
		"ru": "Мы не смогли найти такую ​​бронь.",
		"ua": "Ми не змогли знайти такого бронювання."
	},

	"are_u_sure_u_want_to_cancel_your_appointment": {
		"en": "Are you sure you want to cancel your appointment?",
		"pl": "Na pewno chcesz anulować rezerwację wizyty?",
		"ru": "Вы уверены, что хотите отменить встречу?",
		"ua": "Ви впевнені, що хочете скасувати зустріч?"
	},

	"to_cancel_a_booking_click_on_the_link": {
		"en": "To cancel a booking, click on the link",
		"pl": "Aby anulować rezerwację kliknij w link",
		"ru": "Чтобы отменить бронирование, нажмите на ссылку",
		"ua": "Щоб скасувати бронювання, натисніть на посилання"
	},

	"go_to_the_homepage": {
		"en": "Go to the home page",
		"pl": "Przejdź do strony głównej",
		"ru": "Перейти на главную страницу",
		"ua": "Перейти на домашню сторінку"
	},

	"to_make_new_booking_1": {
		"en": "To make a new booking, go to the",
		"pl": "Aby dokonać nowej rezerwacji przejdź do",
		"ru": "Чтобы сделать новое бронирование, перейдите на",
		"ua": "Щоб зробити нове бронювання, перейдіть на"
	},

	"to_make_new_booking_main_page": {
		"en": "home page",
		"pl": "strony głównej",
		"ru": "главную страницу",
		"ua": "головну сторінку"
	},

	"to_make_new_booking_2": {
		"en": "or call the Helpline number of the City Hall",
		"pl": "lub zadzwoń na numer Infolinii Urzędu Miasta",
		"ru": "или позвоните по номеру горячей линии мэрии",
		"ua": "або зателефонуйте на гарячу лінію мерії"
	},

	"page_not_found": {
		"en": "Page not found",
		"pl": "Strony nie odnaleziono",
		"ru": "Страница не найдена",
		"ua": "Сторінку не знайдено"
	},

	"go_back_to_the_home_page": {
		"en": "Go back to the home page",
		"pl": "Wróć do strony głównej",
		"ru": "Вернуться на главную страницу",
		"ua": "Повернутися на домашню сторінку"
	},

	"important_information": {
		"en": "Important information",
		"pl": "Ważne informacje",
		"ru": "Важная информация",
		"ua": "Важлива інформація"
	},

	"select_a_service_centre": {
		"en": "You have to choose the point where you want to settle your case.",
		"pl": "Musisz wybrać punkt, w którym chcesz załatwić swoją sprawę.",
		"ru": "Вы должны выбрать пункт, где вы хотите уладить свое дело.",
		"ua": "Ви повинні вибрати пункт, де ви хочете вирішити свою справу."
	},

	"selected_service_centre": {
		"en": "Selected service centre",
		"pl": "Wybrany punkt obsługi",
		"ru": "Выбранный пункт обслуживания",
		"ua": "Обраний пункт обслуговування"
	},

	"selected_date": {
		"en": "Selected date",
		"pl": "Wybrany termin",
		"ru": "Выбранная дата",
		"ua": "Обраний термін"
	},

	"address": {
		"en": "Address",
		"pl": "Adres",
		"ru": "Адрес",
		"ua": "Адреса"
	},

	"position": {
		"en": "Position",
		"pl": "Stanowisko",
		"ru": "Позиция",
		"ua": "Позиція"
	},

	"service": {
		"en": "Service",
		"pl": "Usługa",
		"ru": "Услуга",
		"ua": "Послуга"
	},

	"reservation_number": {
		"en": "Reservation number",
		"pl": "Numer rezerwacji",
		"ru": "Номер брони",
		"ua": "Номер бронювання"
	},
	
	"time": {
		"en": "Time",
		"pl": "Godzina",
		"ru": "Время",
		"ua": "Час"
	},
	
	"map": {
		"en": "Map",
		"pl": "Mapa",
		"ru": "Карта",
		"ua": "Карта"
	},

	"previous": {
		"en": "Previous",
		"pl": "Wróć",
		"ru": "Назад",
		"ua": "Назад"
	},

	"next": {
		"en": "Next",
		"pl": "Dalej",
		"ru": "Вперед",
		"ua": "Вперед"
	},

	"back": {
		"en": "Back",
		"pl": "Wróć",
		"ru": "Вернуться",
		"ua": "Повернутися"
	},

   "personal_visit": {
      "en": "Personal visit",
      "pl": "Wizyta osobista",
      "ru": "Личный визит",
      "ua": "Особистий візит"
   },

   "schedule_video_call": {
      "en": "SCHEDULE A VIDEO CALL",
      "pl": "UMÓW SIĘ NA WIDEOROZMOWĘ",
      "ru": "ОРГАНИЗОВАТЬ ВИДЕОЗВОНОК",
      "ua": "ОРГАНІЗУВАТИ ВІДЕОДЗВІНОК"
   },

	"i_prefer_personally": {
		"en": "I prefer personally",
		"pl": "Wolę osobiście",
		"ru": "Я предпочитаю лично",
		"ua": "Я віддаю перевагу особисто"
	},

   "i_prefer_personally_2": {
      "en": "MAKE AN APPOINTMENT TO VISIT IN PERSON",
      "pl": "UMÓW SIĘ NA WIZYTĘ OSOBISTĄ",
      "ru": "ЗАПИШИТЕСЬ НА ЛИЧНЫЙ ВИЗИТ",
      "ua": "ЗАПИСАТИСЯ НА ОСОБИСТИЙ ВІЗИТ"
   },

	"go_to_e_service": {
		"en": "Go to E-service",
		"pl": "Przechodzę do E-usługi",
		"ru": "Перейти в Е-сервис",
		"ua": "Перейти до Е-сервiсу"
	},

	"create_a_trusted_profile": {
		"en": "Create a trusted profile",
		"pl": "ZAŁÓŻ PROFIL ZAUFANY",
		"ru": "СОЗДАТЬ НАДЕЖНЫЙ ПРОФИЛЬ",
		"ua": "СТВОРИТЬ ДОВІРЕНИЙ ПРОФІЛЬ"
	},
	
	"extra_cu_heading": {
		"en": "You can settle the selected issue online without leaving your home, at any time of the day",
		"pl": "Wybraną sprawę możesz załatwić przez internet bez wychodzenia z domu, o każdej porze dnia",
		"ru": "Вы можете решить выбранный вопрос онлайн, не выходя из дома, в любое время суток",
		"ua": "Ви можете вирішити обрану справу в Інтернеті, не виходячи з дому, в будь-який час доби"
	},

   "extra_cu_online_heading": {
      "en": "If you have questions about the selected case, you can discuss them with the official during the video call",
      "pl": "Jeśli masz pytania w związku z wybraną sprawę, możesz omówić je z urzędnikiem podczas wideorozmowy",
      "ru": "Если у вас есть вопросы по выбранному делу, вы можете обсудить их с официальным представителем во время видеозвонка",
      "ua": "Якщо у вас є питання щодо обраної вами справи, ви можете обговорити їх з посадовцем під час відеодзвінка"
   },

	"extra_cu_heading_2": {
		"en": "Don’t have a trusted profile yet?",
		"pl": "Nie masz jeszcze profilu zaufanego?",
		"ru": "У вас еще нет доверенного профиля?",
		"ua": "У вас ще немає надійного профілю?"
	},

	"select_a_service_category": {
		"en": "Select a service category",
		"pl": "Wybierz kolejkę, do której chcesz zarezerwować wizytę",
		"ru": "Выберите категорию услуги",
		"ua": "Виберіть категорію послуги"
	},

	"select_a_queue": {
		"en": "You have to choose the сase you want to make an appointment for.",
		"pl": "Musisz wybrać referat, do którego chcesz się umówić.",
		"ru": "Вы должны выбрать дело, на которое хотите записаться.",
		"ua": "Вам потрібно вибрати справу, на яку ви хочете записатися"
	},

	"select_a_service_type": {
		"en": "You have to choose the type of case you want to settle.",
		"pl": "Musisz wybrać rodzaj sprawy, którą chcesz załatwić.",
		"ru": "Вы должны выбрать тип дела, которое хотите урегулировать.",
		"ua": "Ви повинні вибрати тип справи, який ви хочете вирішити."
	},

	"select_an_appointment_date": {
		"en": "Select an appointment date",
		"pl": "Wybierz termin rezerwacji",
		"ru": "Выберите дату бронирования",
		"ua": "Виберіть дату бронювання"
	},

	"choose_a_date_and_time": {
		"en": "To make an appointment, you must choose the day and time.",
		"pl": "Aby umówić wizytę musisz wskazać dzień oraz godzinę.",
		"ru": "Для записи на прием необходимо указать день и время.",
		"ua": "Щоб записатися на прийом, необхідно вказати день і час."
	},

	"check_if_all_details_are_correct": {
		"en": "Check if all the details are correct",
		"pl": "Sprawdź poprawność danych",
		"ru": "Проверьте правильность данных",
		"ua": "Перевірте правильність даних"
	},

	"reservation_confirmation": {
		"en": "Reservation confirmation",
		"pl": "Potwierdzenie rezerwacji",
		"ru": "Подтверждение бронирования",
		"ua": "Підтвердження бронювання"
	},

	"step_6_phone_error": {
		"en": "A telephone number is not required if you confirm your visit with your e-mail address.",
		"pl": "Numer telefonu nie jest wymagany w przypadku potwierdzenia wizyty za pomocą adresu e-mail.",
		"ru": "Номер телефона не требуется, если вы подтверждаете свой визит адресом электронной почты.",
		"ua": "Номер телефону не потрібен, якщо ви підтверджуєте свій візит своєю адресою електронної пошти."
	},

	"step_6_email_error": {
		"en": "An e-mail address is not required when confirming the visit by phone.",
		"pl": "Adres e-mail nie jest wymagany w przypadku potwierdzenia wizyty za pomocą telefonu.",
		"ru": "Адрес электронной почты не требуется при подтверждении визита по телефону.",
		"ua": "При підтвердженні візиту по телефону адреса електронної пошти не потрібна."
	},

	"booking_week_expired": {
		"en": "You cannot select an appointment that has already passed. Free dates for the next week will be unlocked on Friday at 7:00.",
		"pl": "Nie możesz wybrać terminu, który już minął. Wolne terminy na kolejny tydzień zostaną odblokowane w piątek o 7:00.",
		"ru": "Вы не можете выбрать дату, которая уже прошла. Свободные даты на следующую неделю будут разблокированы в пятницу в 7:00.",
		"ua": "Ви не можете вибрати дату, яка вже пройшла. Вільні дати на наступний тиждень будуть розблоковані в п’ятницю о 7:00."
	},

	"booking_week_not_available": {
		"en": "All time on the selected date have already been booked. Free dates for the next week will be unlocked on Friday at 7:00.",
		"pl": "Wszystkie terminy w wybranym dniu zostały już zarezerwowane. Wolne terminy na kolejny tydzień zostaną odblokowane w piątek o 7:00.",
		"ru": "Все время на выбранную дату уже забронировано. Свободные даты на следующую неделю будут разблокированы в пятницу в 7:00.",
		"ua": "Усі часы на вибрану дату вже заброньовані. Вільні дати на наступний тиждень будуть розблоковані в п’ятницю о 7:00."
	},

	"booking_hours_not_available": {
		"en": "The selected time of visit has already been taken, select the time marked in green. Free dates for the next week will be unlocked on Friday at 7:00.",
		"pl": "Wybrana godzina wizyty została już zajęta, wybierz godzinę oznaczoną kolorem zielonym. Wolne terminy na kolejny tydzień zostaną odblokowane w piątek o 7:00.",
		"ru": "Выбранное время посещения уже занято, выберите время, отмеченное зеленым. Свободные даты на следующую неделю будут разблокированы в пятницу в 7:00.",
		"ua": "Вибраний час відвідування вже зайнято, виберіть час, позначений зеленим кольором. Безкоштовні дати на наступний тиждень будуть розблоковані в п’ятницю о 7:00."
	},

	"time_not_available": {
		"en": "Time not available",
		"pl": "Zajęta godzina",
		"ru": "Время занято",
		"ua": "Зайнятий час"
	},

	"time_available": {
		"en": "Time available",
		"pl": "Wolna godzina",
		"ru": "Свободное время",
		"ua": "Вільний час"
	},

	"check_if_date_and_time_are_correct": {
		"en": "Check if date and time are correct",
		"pl": "Upewnij się, że poprawnie wybrałeś/aś termin",
		"ru": "Убедитесь, что вы правильно выбрали дату и время",
		"ua": "Переконайтеся, що ви правильно вибрали дату та час"
	},

	"familiarize_yourself_with_the_procedure": {
		"en": "Familiarize yourself with the procedure, the amount of the fee and the required documents",
		"pl": "Zapoznaj się z procedurą, wysokością opłaty oraz wymaganymi dokumentami",
		"ru": "Ознакомьтесь с процедурой, размером сбора и необходимыми документами",
		"ua": "Ознайомтеся з процедурою, розміром збору та необхідними документами"
	},

	"chose_a_confirmation_method": {
		"en": "Choose a confirmation method",
		"pl": "Wybierz sposób potwierdzenia rezerwacji",
		"ru": "Выберите способ подтверждения резервации",
		"ua": "Виберіть спосіб підтвердження бронювання"
	},

	"enter_your_details": {
		"en": "Enter your details",
		"pl": "Podaj swoje dane",
		"ru": "Введите свои данные",
		"ua": "Введіть свої дані"
	},

	"first_name_and_last_name": {
		"en": "First name and last name",
		"pl": "Imię i nazwisko",
		"ru": "Имя и фамилия",
		"ua": "Ім’я та прізвище"
	},

	"phone_number": {
		"en": "Phone number",
		"pl": "Numer telefonu",
		"ru": "Номер телефона",
		"ua": "Телефонний номер"
	},

	"e_mail_address": {
		"en": "E-mail adress",
		"pl": "Adres e-mail",
		"ru": "Электронная почта",
		"ua": "Електронна пошта"
	},

	"acceptance_checkbox_1": {
		"en": "I declare that I have read the",
		"pl": "Oświadczam, że zapoznałem/łam się z",
		"ru": "Я ознакомился/лась c",
		"ua": "Я заявляю, що ознайомився/лась з"
	},

	"acceptance_checkbox_2": {
		"en": "Regulations of the telephone and online booking of a visit to the Gdynia City Hall and the use of online payments for official activities",
		"pl": "Regulaminem telefonicznej i internetowej rezerwacji wizyty w Urzędzie Miasta Gdyni oraz korzystania z płatności online za dokonanie czynności urzędowych",
		"ru": "Правилами телефонного и онлайн-бронирования посещения мэрии Гдыни и использования онлайн-платежей для официальной деятельности",
		"ua": "Регламетом телефонного та онлайн-бронювання відвідування мерії Гдині та використання онлайн-платежів за офіційні заходи"
	},

	"acceptance_checkbox_3": {
		"en": "and I accept all conditions included herein",
		"pl": "i akceptuję wszystkie zawarte w nim warunki",
		"ru": "и принимаю все, содержащиеся в них, условия",
		"ua": "і приймаю всі умови, що містяться в ньому"
	},

	"accessibility_declaration": {
		"en": "Accessibility declaration",
		"pl": "Deklaracja dostępności",
		"ru": "Декларация доступности",
		"ua": "Декларація доступності"
	},

	"user_manual": {
		"en": "User manual",
		"pl": "Instrukcja obsługi",
		"ru": "Руководство пользователя",
		"ua": "Посібник користувача"
	},

	"terms_and_conditions_of_booking_a_visit": {
		"en": "Terms and conditions",
		"pl": "Regulamin rezerwacji wizyty",
		"ru": "Условия бронирования",
		"ua": "Умови бронювання"
	},

	"booking_of_visits": {
		"en": "Booking of visits",
		"pl": "Rezerwacja wizyt",
		"ru": "Бронирование посещений",
		"ua": "Бронювання відвідувань"
	},

	"booking_an_appointment": {
		"en": "Book an appointment",
		"pl": "Rezerwacja terminu wizyty",
		"ru": "Бронирование даты визита",
		"ua": "Бронювання дати візиту"
	},

	"book_an_appointment": {
		"en": "Book an appointment",
		"pl": "Rezerwuj termin",
		"ru": "Записаться на прием",
		"ua": "Замовити зустріч"
	},

	"smaller_font_size": {
		"en": "smaller font size",
		"pl": "mniejszy rozmiar czcionki",
		"ru": "меньший размер шрифта",
		"ua": "менший розмір шрифту"
	},

	"normal_font_size": {
		"en": "normal font size",
		"pl": "normalny rozmiar czcionki",
		"ru": "нормальный размер шрифта",
		"ua": "нормальний розмір шрифту"
	},

	"larger_font_size": {
		"en": "larger font size",
		"pl": "większy rozmiar czcionki",
		"ru": "больший размер шрифта",
		"ua": "більший розмір шрифту"
	},

	"switch_contrast_version": {
		"en": "Switch contrast version",
		"pl": "Przełącz wersję kontrastu",
		"ru": "Переключить контрастную версию",
		"ua": "Переключити контрастну версію"
	},

	"online_clerk": {
		"en": "Clerk online",
		"pl": "Urzędnik online",
		"ru": "Чиновник онлайн",
		"ua": "Чиновник онлайн"
	},

	"field_is_required": {
		"en": "Field is required!",
		"pl": "Pole jest wymagane!",
		"ru": "Поле обязательно для заполнения!",
		"ua": "Поле обов'язкове!"
	},

	"incorrect_email_format": {
		"en": "Incorrect e-mail format!",
		"pl": "Niepoprawny format adresu e-mail!",
		"ru": "Неправильный формат электронной почты!",
		"ua": "Неправильний формат електронної пошти!"
	},

	"please_select_the_method_of_booking_confirmation": {
		"en": "Please select the method of booking confirmation!",
		"pl": "Proszę zaznaczyć sposób potwierdzenia rezerwacji!",
		"ru": "Пожалуйста, выберите способ подтверждения бронирования!",
		"ua": "Виберіть спосіб підтвердження бронювання!"
	},

	"invalid_phone_number": {
		"en": "Invalid phone number!",
		"pl": "Niepoprawny numer telefonu!",
		"ru": "Неправильный номер телефона!",
		"ua": "Недійсний номер телефону!"
	},

	"acceptance_is_required": {
		"en": "To make a reservation, you must accept the content of the regulations and consent to the processing of personal data.",
		"pl": "Aby dokonać rezerwacji musisz zaakceptować treść regulaminu oraz wyrazić zgodę na przetwarzanie danych osobowych.",
		"ru": "Для оформления бронирования необходимо принять содержание регламента и дать согласие на обработку персональных данных.",
		"ua": "Щоб зробити бронювання, ви повинні прийняти зміст регламенту та дати згоду на обробку персональних даних."
	},

	"reservation_lock_time_expired": {
		"en": "Reservation lock time expired! You can start over by clicking the button below",
		"pl": "Czas blokady rezerwacji minął! Możesz zacząć od nowa klikając poniższy przycisk",
		"ru": "Время блокировки резервирования истекло! Вы можете начать все сначала, нажав кнопку ниже",
		"ua": "Час блокування бронювання закінчився! Ви можете почати заново, натиснувши кнопку нижче"
	},

	"reservation_lock_time": {
		"en": "Temporary reservation",
		"pl": "Czas blokady rezerwacji",
		"ru": "Время блокировки бронирования",
		"ua": "Час блокування бронювання"
	},

	"enter_the_code_you_get_via_text_message": {
		"en": "Enter the code you get via text message",
		"pl": "Wprowadź otrzymany kod SMS",
		"ru": "Введите полученный SMS-код",
		"ua": "Введіть отриманий SMS-код"
	},

	"confirm_your_booking": {
		"en": "Confirm your booking",
		"pl": "Potwierdż rezerwację",
		"ru": "Подтвердите ваше бронирование",
		"ua": "Підтвердьте своє бронювання"
	},

	"back_to_the_booking_page": {
		"en": "Back to the booking page",
		"pl": "Powrót do strony rezerwacji",
		"ru": "Вернуться на страницу бронирования",
		"ua": "Повернутися на сторінку бронювання"
	},

	"the_visit_has_been_booked": {
		"en": "The visit has been booked. Check your email inbox to confirm your booking.",
		"pl": "Wizyta została zarezerowowana. Sprawdź swoją skrzynkę email, aby potwierdzić rezerwację.",
		"ru": "Визит был забронирован. Проверьте свой почтовый ящик, чтобы подтвердить бронирование.",
		"ua": "Візит заброньовано. Перевірте свою поштову скриньку, щоб підтвердити своє бронювання."
	},

	"reservation_error": {
		"en": "Reservation error",
		"pl": "Błąd rezerwacji",
		"ru": "Ошибка бронирования",
		"ua": "Помилка бронювання"
	},

	"return": {
		"en": "Return",
		"pl": "Powrót",
		"ru": "Вернуться",
		"ua": "Повернутися"
	},

	"reservation_handling_manual": {
		"en": "Reservation Handling Manual",
		"pl": "Instrukcja Obsługi Rezerwacji Wizyty",
		"ru": "Руководство по оформлению бронирования",
		"ua": "Посібник з оформлення бронювання"
	},

	"see_content_in_pjm": {
		"en": "See content in PJM",
		"pl": "Zobacz treść w PJM",
		"ru": "Смотрите контент в PJM",
		"ua": "Дивіться вміст у PJM"
	},

	"user_manual_in_pjm": {
		"en": "User manual in PJM",
		"pl": "Instrukcja obsługi w PJM",
		"ru": "Руководство пользователя в PJM",
		"ua": "Посібник користувача в PJM"
	},

	"next_available_date": {
		"en": "Next available date",
		"pl": "Najbliższy wolny termin",
		"ru": "Ближайшая доступная дата",
		"ua": "Найближчий вільний термін"
	},

	"monday": {
		"en": "Monday",
		"pl": "Poniedziałek",
		"ru": "Понедельник",
		"ua": "Понеділок"
	},

	"tuesday": {
		"en": "Tuesday",
		"pl": "Wtorek",
		"ru": "Вторник",
		"ua": "Вівторок"
	},

	"wednesday": {
		"en": "Wednesday",
		"pl": "Środa",
		"ru": "Среда",
		"ua": "Середа"
	},

	"thursday": {
		"en": "Thursday",
		"pl": "Czwartek",
		"ru": "Четверг",
		"ua": "Четвер"
	},

	"friday": {
		"en": "Friday",
		"pl": "Piątek",
		"ru": "Пятница",
		"ua": "П'ятниця"
	},

	"saturday": {
		"en": "Saturday",
		"pl": "Sobota",
		"ru": "Суббота",
		"ua": "Субота"
	},

	"sunday": {
		"en": "Sunday",
		"pl": "Niedziela",
		"ru": "Воскресенье",
		"ua": "Неділя"
	},

	"mon": {
		"en": "Mon",
		"pl": "Pon",
		"ru": "Пон",
		"ua": "Пон"
	},

	"tue": {
		"en": "Tue",
		"pl": "Wt",
		"ru": "Вт",
		"ua": "Вів"
	},

	"wed": {
		"en": "Wed",
		"pl": "Śro",
		"ru": "Ср",
		"ua": "Сер"
	},

	"thu": {
		"en": "Thu",
		"pl": "Czw",
		"ru": "Чет",
		"ua": "Чет"
	},

	"fri": {
		"en": "Fri",
		"pl": "Pią",
		"ru": "Пят",
		"ua": "П'ят"
	},

	"sat": {
		"en": "Sat",
		"pl": "Sb",
		"ru": "Суб",
		"ua": "Суб"
	},

	"sun": {
		"en": "Sun",
		"pl": "Nied",
		"ru": "Вос",
		"ua": "Нед"
	}
}